// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretDownOutlinedSvg from "@fishx/icons-svg/es/asn/CaretDownOutlined";
import FishxIcon from '../components/FishxIcon';

var CaretDownOutlined = function CaretDownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretDownOutlinedSvg
  }));
};

CaretDownOutlined.displayName = 'CaretDownOutlined';
export default React.forwardRef(CaretDownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretDownOutlined.js
// module id = 2163
// module chunks = 0